export enum ErrorType {
  FORBIDDEN = "FORBIDDEN"
}
